<template>
  <div class="header">
    <div
      class="menu"
      @click="changeSlidWidth"
    >
      <i :class="['iconfont', 'icon-menu', isSlidbarOpen ? 'icon-collapse' : 'icon-expand']" />
    </div>
    <el-dropdown>
      <div class="person-info">
        <div class="info-head-img">
          <img
            :src="getAvatarUrl(userInfo.avatar)"
            alt=""
          />
        </div>
        <span class="info-name">
          {{ userInfo.realName }}
          <i class="iconfont icon-jiantou icon-down-triangle"></i>
        </span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <EDialogTips
      ref="dialogTips"
      :tips-info="tipsInfo"
      @confirm="confirmLogout"
    />
  </div>
</template>
<script>
import {mapState} from 'vuex';
import {Storage} from '@/utils/common';
export default {
  name: 'Header',
  data() {
    return {
      tipsInfo: {
        title: '提示',
        content: '确定要退出登录吗？'
      }
    };
  },
  computed: {
    ...mapState('config', ['isSlidbarOpen'])
  },
  methods: {
    // 获取用户头像
    getAvatarUrl(avatar) {
      return avatar || require('@/assets/images/default-img.png');
    },
    // 侧边栏开关
    changeSlidWidth() {
      this.$store.commit('config/SET_SLIDBAR_OPEN', !this.isSlidbarOpen);
    },
    // 退出登录
    logout() {
      this.$refs.dialogTips.open();
    },
    confirmLogout() {
      Storage.remove('userInfo');
      Storage.remove('auth');
      Storage.remove('token');
      this.$router.replace('/');
    }
  }
};
</script>
<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #fff;
  padding: 0px 24px;
  height: 52px;
  box-sizing: border-box;
  .menu {
    cursor: pointer;
    font-size: 20px;
    border: 1px solid @border-color;
    border-radius: 8px;
    width: 32px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-menu {
      font-size: 20px;
    }
  }
  .person-info {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: @content-color;
    .info-head-img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info-name {
      margin-left: 10px;
      .icon-jiantou {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}
</style>
